import { Button } from "@closer/ui";
import { Link, useNavigate, useSearchParams } from "react-router";

import { AuthLayout } from "../../layouts/AuthLayout";

/**
 * SOSYAL GİRİŞ HATASI (CLOS-805).
 *
 * ⚠ Bu ekran bir süre KARTSIZ durdu (26 Ağustos). İlk yazımında gerekçe olarak CLOS-335
 * gösterilmişti; o kartın kapsamı ve beş kabul kriteri tamamen sunucu tarafı (hesap
 * eşleştirme, bağlama, ele geçirme koruması) ve hiçbir ekran tanımlamıyor — ADR-0018 de
 * tanımlamıyor. Yani yeni bir sayfa ve yeni bir rota ADR-0014'e aykırı biçimde eklendi.
 * Denetimde yakalandı, CLOS-805 açıldı ve kod o karta bağlandı.
 *
 * ### ⚠ Kullanıcı BetterAuth'un ham sayfasında kalmasın
 *
 * OAuth turu hata verdiğinde kütüphane kendi `/api/auth/error` sayfasını basıyordu:
 * İngilizce, "Something went wrong", ham hata kodu ve ürünle hiçbir bağı olmayan iki
 * bağlantı. Kullanıcı kendi ekranımızdan çıkıp bir hata ayıklama sayfasına düşüyor ve ne
 * yapacağını hiçbir yerde okumuyordu — kullanıcı bildirdi (26 Ağustos).
 *
 * ### ⚠ `account_not_linked` bir ARIZA DEĞİL, kural
 *
 * Aynı e-postayla şifreli hesap varken Google kendiliğinden bağlanamıyor (ADR-0018):
 * bağlama, aktif oturumla yapılan gerçek bir yeniden doğrulama ister. Ekran bunu "hata"
 * diye değil, SIRAYLA anlatıyor — önce şifreyle gir, sonra profilinden bağla — çünkü
 * kullanıcının burada öğrenmesi gereken şey bir arıza değil, izlenecek yol.
 */
const ACIKLAMALAR: Record<string, { baslik: string; anlatim: string }> = {
  account_not_linked: {
    baslik: "Bu e-posta şifreyle açılmış bir hesaba ait",
    anlatim:
      "Güvenlik gereği Google hesabı, mevcut bir hesaba kendiliğinden bağlanmıyor. Önce " +
      "şifrenizle giriş yapın; ardından profilinizden Google'ı bağlayabilir ve bundan sonra " +
      "Google ile girebilirsiniz. Şifrenizi bilmiyorsanız “Şifremi unuttum” ile " +
      "yenileyin.",
  },
  signup_disabled: {
    baslik: "Bu yöntemle yeni hesap açılamıyor",
    anlatim:
      "Google ile gelen adrese ait bir hesap bulunamadı. Önce e-posta ve şifreyle kaydolun, " +
      "sonra Google'ı hesabınıza bağlayın.",
  },
  email_not_verified: {
    baslik: "E-posta adresi doğrulanmamış",
    anlatim:
      "Sağlayıcıdan gelen e-posta doğrulanmış görünmüyor; bu adresle giriş yapılamıyor. " +
      "Şifrenizle giriş yapıp e-postanızı doğruladıktan sonra tekrar deneyin.",
  },
};

const VARSAYILAN = {
  baslik: "Giriş tamamlanamadı",
  anlatim:
    "Sağlayıcıyla yapılan tur beklenmedik bir şekilde sonlandı. Şifrenizle giriş yapmayı " +
    "deneyebilir ya da birkaç dakika sonra tekrar deneyebilirsiniz.",
};

export function AuthErrorPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const kod = params.get("error");
  const icerik = (kod ? ACIKLAMALAR[kod] : undefined) ?? VARSAYILAN;

  return (
    <AuthLayout title={icerik.baslik}>
      <div className="flex flex-col gap-4">
        <p className="text-sm text-fg">{icerik.anlatim}</p>

        <div className="flex flex-wrap gap-2">
          <Button type="button" onClick={() => void navigate("/login")}>
            Şifreyle giriş yap
          </Button>
          <Link
            to="/forgot-password"
            className="inline-flex items-center text-sm font-medium text-primary hover:underline"
          >
            Şifremi unuttum
          </Link>
        </div>

        {/*
          ⚠ HAM KOD GÖSTERİLMİYOR — ilk yazımda gösteriliyordu, CLOS-805 denetiminde kaldırıldı.

          İki gerekçe ve ikisi de bağımsız:

          1. Kartın kabul kriteri açık: *"Hata kodu ve ayrıntısı kullanıcıya sızdırılmaz."*
             Eski kodun yanındaki not ("destek istendiğinde kullanıcı neyi söyleyeceğini
             bilmeli") makul bir istek ama kanon değil; destek izlenebilirliği istenirse
             kendi kartıyla gelir (ADR-0014).
          2. `kod` DOĞRUDAN URL'DEN geliyor ve bu sayfaya oturumsuz erişiliyor. Basıldığında
             saldırgan `?error=...` ile kendi cümlesini ÜRÜNÜN kendi giriş ekranında
             yazdırabiliyordu: React kaçışladığı için XSS değil, ama alan adımızın güvenilir
             görüntüsünü ödünç veren bir oltalama yüzeyi ("Hesabınız donduruldu, şu numarayı
             arayın"). Bilinen kodların metni artık YALNIZ bu dosyadaki sözlükten geliyor.
        */}
      </div>
    </AuthLayout>
  );
}
